const checkUserBrowser = () => {
    const body = document.querySelector("body");
    // Internet Explorer 6-11

    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Chrome 1 - 79

    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    // Edge (based on chromium) detection
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

    // IE
    if(isIE) {
        body.dataset.userBrowser = 'IE';
    }

    // Edge
    if(isEdgeChromium) {
        body.dataset.userBrowser = 'Edge';
    }

    // Opera
    else if((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
        body.dataset.userBrowser = 'Opera';
    }

    // Chrome
    else if(isChrome) {
        body.dataset.userBrowser = 'Chrome';
    }

    // Firefox
    else if(typeof InstallTrigger !== 'undefined') {
        body.dataset.userBrowser = 'Firefox';
    }
}

export default checkUserBrowser;
